import axios from 'axios'
import qs from 'qs'
import {
  router
} from '../router'
import store from '../store'
import Cookies from 'js-cookie'
import {
  Message
} from 'element-ui'
import util from '@/base/js/util'

//开发环境：/dev + '接口'
//生产环境：/admin + '接口'
const DEV_URL_ENV = '/dev'
const PRO_URL_ENV = '/admin'

let isAlpha = process.env.VUE_APP_TITLE === 'alpha' ? true : false

//创建全局axios对象
const req = axios.create({
  timeout: 60000,
  paramsSerializer: function (params) {
    return qs.stringify(params, {
      arrayFormat: 'brackets'
    })
  },
  transformRequest: function (data) {
    if (isAlpha) {
      data += '&yj=1'
    }
    return data
  }
})

//登录过期，清空信息，跳转至登录页
const clearLogin = () => {
  Message.warning('登录状态发生变化')
  // Cookies.set('PHPSESSION', '')
  // Cookies.set('token', '')
  util.removeSession('userInfo')
  location.reload()
  // store.dispatch('removeRoutes')
  // router.replace({
  //   name: 'login'
  // })
}

// 下载文件
const downloadUrl = url => {
  let iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.src = url
  iframe.onload = function () {
    document.body.removeChild(iframe)
  }
  document.body.appendChild(iframe)
}

// 添加请求拦截器
req.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  //请求前校验token，校验用户登录状态
  // const cookie_token = Cookies.get('token')
  // const store_token = store.state.userInfo.token
  // if (store_token && cookie_token && cookie_token != store_token) {
  //   Message.warning('登录状态发生变化')
  //   location.reload()
  // }
  if (isAlpha) {
    if (config.params) {
      config.params.yj = 1
    } else {
      config.params = {
        yj: 1
      }
    }
  }
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
});


// 添加响应拦截器
req.interceptors.response.use(res => {
  //未登录跳转置登录页面且清空登录信息
  // if (res.data.resultCode === -2) {
  //   clearLogin()
  //   return res
  // }
  // 登录状态发生变化
  if (res.data.resultCode == -40001 || res.data.resultCode == -2) {
    clearLogin()
    return res
  }

  // 处理excel文件
  if (res.headers && (res.headers['content-type'] === 'application/vnd.ms-excel' || res.headers['content-type'] === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
    downloadUrl(res.request.responseURL)
    res.data = '';
    res.headers['content-type'] = 'text/json'
    return res
  }
  return res;
}, error => {
  // Do something with response error
  return Promise.reject(error.response.data || error.message)
})

const request = (config) => {
  //根据环境来判断接口目录(VUE_APP_TITLE：production生产环境，alpha测试环境)
  // let URL_ENV = process.env.NODE_ENV === 'production'
  //   ? process.env.VUE_APP_TITLE === 'production'
  //     ? PRO_URL_ENV
  //     : DEV_URL_ENV
  //   : DEV_URL_ENV
  // config.url = URL_ENV + config.url

  //缓存是否使用自定义callback函数配置项
  let isCustomCallBack
  if (config.isCustomCallBack) {
    //缓存该属性
    isCustomCallBack = config.isCustomCallBack
    //删除配置项中的属性，防止提交到后台
    delete config.isCustomCallBack
  }

  return req.request(config)
    .then(res => {
      return res.data
      // if (isCustomCallBack) {
      //   return res.data
      // } else {
      //   if (res.data.resultCode == 1) {
      //     return res.data
      //   } else if (res.resultCode == 0) {
      //     Message.error(res.errorMsg)
      //   }
      // }
    })
    .catch(error => {
      Message.error('服务器端出现错误，请联系开发人员')
      console.log(error)
    })
}
export default request